import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/shadcn/Popover/Popover";
import * as Tooltip from "@radix-ui/react-tooltip";
import { cn } from "@/lib/utils/cn";
import { Typography } from "../../Typography/Typography";

export interface TooltipWrapperProps {
  children: React.ReactNode;
  message: string | React.ReactNode;
  delayDuration?: number;
  contentClassName?: string;
}

export function TooltipWrapper(props: TooltipWrapperProps) {
  // check if touch device
  const isTouchDevice = window.matchMedia("(hover: none)").matches;
  if (isTouchDevice) {
    return (
      <Popover>
        <PopoverTrigger asChild>{props.children}</PopoverTrigger>
        <PopoverContent
          className={cn(
            "border-none shadow-none",
            props.contentClassName ?? "bg-light-primary",
          )}
        >
          {props.message}
        </PopoverContent>
      </Popover>
    );
  }
  return (
    <Tooltip.Provider delayDuration={props.delayDuration ?? 100}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{props.children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content
            className={cn(
              "data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade z-[110] max-w-md rounded-md px-[15px] py-[10px] text-[15px] leading-none whitespace-pre-wrap shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] will-change-[transform,opacity] select-none",
              props.contentClassName ?? "bg-light-primary",
            )}
            sideOffset={5}
            collisionPadding={10}
            hidden={!props.message}
          >
            <Typography size="sm">{props.message}</Typography>

            <Tooltip.Arrow
              className={props.contentClassName ? "fill-popover" : undefined}
            />
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
